module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "pie-chart-box"
    }
  }), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "select-all": "",
      "pagination": _vm.pagination,
      "item-key": "Title",
      "search": _vm.search,
      "no-data-text": "No Disorders Available Currently"
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "headers",
      fn: function(props) {
        return [_c('tr', [_c('th', [_c('v-checkbox', {
          attrs: {
            "primary": "",
            "hide-details": "",
            "input-value": props.all,
            "indeterminate": props.indeterminate
          },
          nativeOn: {
            "click": function($event) {
              return _vm.toggleAll($event)
            }
          }
        })], 1), _vm._v(" "), _vm._l((props.headers), function(header) {
          return _c('th', {
            key: header.text,
            class: ['column sortable', _vm.pagination.descending ? 'desc' : 'asc', header.value === _vm.pagination.sortBy ? 'active' : ''],
            on: {
              "click": function($event) {
                _vm.changeSort(header.value)
              }
            }
          }, [_c('v-icon', [_vm._v("arrow_upward")]), _vm._v("\n            " + _vm._s(header.text) + "\n          ")], 1)
        })], 2)]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          attrs: {
            "active": props.selected
          },
          on: {
            "click": function($event) {
              props.selected = !props.selected
            }
          }
        }, [_c('td', [_c('v-checkbox', {
          attrs: {
            "primary": "",
            "hide-details": "",
            "input-value": props.selected
          }
        })], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.Title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item._omim))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item._modeOfInheritance))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item._genePanelCount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item._geneCount))])])]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, [_c('template', {
    slot: "footer"
  }, [_c('td', {
    attrs: {
      "colspan": "100%"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.selected.length) + " of " + _vm._s(_vm.items.length) + " results selected")])])])], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b5292fd","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/app/components/pages/DiseasesPanel.vue
// module id = 494
// module chunks = 0